import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=52385c9a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=52385c9a&prod&scoped=true&lang=less"
import style1 from "./Header.vue?vue&type=style&index=1&id=52385c9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52385c9a",
  null
  
)

export default component.exports